import Helper from "@ember/component/helper";
import { service } from "@ember/service";
import type IntlService from "ember-intl/services/intl";
import { compute as jeSourceCompute } from "parog-web/helpers/je-source";
import type BioExamResultsReceivedJournalEvent from "parog-web/models/bio-exam-results-received-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

type Positional = Array<BioExamResultsReceivedJournalEvent>;

export interface BioExamResultsSignature {
  Args: {
    Positional: Positional;
  };
  Return: string;
}

export default class extends Helper<BioExamResultsSignature> {
  @service declare intl: IntlService;
  @service declare session: SemeiaSessionService;

  override compute([bioExamResultsJe]: Positional) {
    if (bioExamResultsJe.isFromHprim) {
      const apicryptMessageSender =
        bioExamResultsJe.lastApicryptMessage?.senders?.[0];

      if (!this.session.medic?.bioSenderDisplayed || !apicryptMessageSender) {
        return "via Apicrypt";
      }

      return `via ${apicryptMessageSender}`;
    }
    if (bioExamResultsJe.isFromOru) return "via HL7";
    if (bioExamResultsJe.hlaId) return "via connecteur HLA";
    return jeSourceCompute([bioExamResultsJe], this.intl);
  }
}
